// extracted by mini-css-extract-plugin
export var searchHeader = "_22-0";
export var searchHeaderDark = "_22-1";